import { Component } from 'vue-property-decorator';
import { Block } from '../../../helpers/components';
import { BaseBlock } from '../../base-block';

@Block() @Component
export class ApartmentsOverviewFaqBlock extends BaseBlock {
}

export default ApartmentsOverviewFaqBlock;
